<template>
    <component :is="template">
        <!-- <v-responsive v-if="ready && giftOrder" width="100%">
            <v-card elevation="0" tile max-width="100%">
                <v-card-title class="tit tit--lg">
                    <span class="py-4 pl-4"><b>선물결과</b></span>
                </v-card-title>
            </v-card>

            <v-card elevation="0" tile max-width="100%">
                <v-divider/>
                <v-card-text class="text-center">
                    <div v-if="resCode == '3001'" class="tit tit--xs">[{{ resCode }}] {{ resMessage }}</div>
                    <div v-else class="tit tit--xs">[{{ resCode }}] 결제가 완료되지 않았습니다</div>
                    <div class="font-size-16">
                        <div v-if="resCode == '3001'">결제가 완료되었습니다.</div>
                        <div v-else>결제가 완료되지 않았습니다</div>
                    </div>
                </v-card-text>

                <v-divider/>

                <pickup-item :cart="giftOrder.purchase" />

                <v-divider/>

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0>총 상품가격</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ giftOrder.saleAmount.format() }} 원</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex grow-shrink-0>총 배송비</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ giftOrder.shippingAmount.format() }} 원</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex grow-shrink-0>캐시 사용</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>- {{ giftOrder.cashAmount.format() }} 원</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex grow-shrink-0>포인트 사용</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>- {{ giftOrder.cashAmount.format() }} 원</v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider/>

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0>총 주문 금액</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ giftOrder.totalAmount.format() }} 원</v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider />

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0><b>결제 금액</b></v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0><b>{{ giftOrder.paymentAmount.format() }} 원</b></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">구매자</v-card-title>
                <v-card-text class="pt-0">
                    <v-layout wrap class="mx-n2 mt-n4">
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">이름</div><div class="font-size-14 black--text">{{ giftOrder.buyer.name || "-" }}</div></div></v-flex>
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">연락처</div><div class="font-size-14 black--text">{{ giftOrder.buyer.phone || "-" }}</div></div></v-flex>
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">이메일</div><div class="font-size-14 black--text">{{ giftOrder.buyer.email || "-" }}</div></div></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">수취인(선물받는사람)</v-card-title>
                <v-card-text>
                    <v-layout wrap class="mx-n2 mt-n4">
                        <v-flex xs12 md3 class="mt-4 px-2"><div><div class="font-size-14">연락처</div><div class="font-size-14 black--text">{{ giftOrder.receiver.phone || "-" }}</div></div></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">선물 메세지</v-card-title>
                <v-card-text>
                    {{ giftOrder.message || "-" }}
                </v-card-text>
            </v-card>

            <v-layout class="mt-4" justify-center>
                <v-btn x-large color="white" elevation="0" class="mx-1" to="/">홈으로가기</v-btn>
                <v-btn x-large color="primary" elevation="0" class="mx-1" to="/mypage/shop/gift-purchases">선물내역확인</v-btn>
            </v-layout>

        </v-responsive> -->
        <div v-if="ready && giftOrder">
            <div class="contents-area">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">선물결과</h2>
                </div>
                <div class="contents-area__inner">
                    <section class="page-section pt-0">
                        <v-data-table v-if="resCode ==='3001'" :items="purchases" :headers="purchasesHeaders" disable-pagination disable-sort hide-default-footer mobile-breakpoint="768" width="100%" class="d-flex purchasedetail-table">
                            <template slot="item.product" slot-scope="{item}">
                                <div class="img-wrap border">
                                    <router-link :to="`/shop/products/${item.product._mainProduct || item.product._id}`">
                                        <v-img :src="item?.product?.thumb" width="100" :aspect-ratio="1/1" contain />
                                    </router-link>
                                </div>
                            </template>
                            <v-responsive slot="item.name" slot-scope="{item}">
                                <v-flex>
                                    <router-link :to="`/shop/products/${item.product._mainProduct || item.product._id}`">
                                        <div class="mx-2 text-truncate">{{ item?.product?.name}}</div>
                                    </router-link>
                                </v-flex>
                            </v-responsive>
                            <v-responsive slot="item.saleAmount" slot-scope="{item}">
                                <v-flex>
                                    <div class="mx-2 text-truncate">{{ item.saleAmount.format() }}원</div>
                                </v-flex>
                            </v-responsive>
                            <v-responsive slot="item.earnPointAmount" slot-scope="{item}">
                                <v-flex>
                                    <div class="mx-2 text-truncate">{{ item.earnPointAmount.format() }}원</div>
                                </v-flex>
                            </v-responsive>
                        </v-data-table>
                        <div v-else>
                            <div>[{{ resCode }}]</div>
                            <div>결제가 완료되지 않았습니다</div>
                        </div>
                    </section>

                    <section class="page-section py-0">
                        <div class="card--primary">
                            <v-row align="center" justify="center" class="row--x-small font-size-14 font-size-md-16">
                                <v-col cols="auto">
                                    <span>상품(<b>{{ giftOrder?.saleAmount.format() || 0 }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">+</v-col>
                                <v-col cols="auto">
                                    <span>배송비(<b>{{ giftOrder?.shippingAmount.format()|| 0 }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col cols="auto">
                                    <span>적립금 사용(<b>{{ giftOrder?.pointAmount.format() || 0 }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col cols="auto">
                                    <span>캐시 사용(<b>{{ giftOrder?.cashAmount.format() || 0 }}원</b>)</span>
                                </v-col>
                                <v-col cols="auto">=</v-col>
                                <v-col cols="auto">
                                    <div class="d-flex align-center">
                                        <span>총 결제 금액</span><b class="font-size-20 font-size-md-24 ml-10px ml-md-12px">{{ totalAmount.format() }}원</b>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </section>

                    <section class="page-section">
                        <table class="table--default">
                            <colgroup>
                                <col style="width:20%">
                                <col style="width:30%">
                                <col style="width:20%">
                                <col style="width:30%">
                            </colgroup>
                            <tr>
                                <th>주문번호</th>
                                <td>{{giftOrder?.orderNo}}</td>
                                <th>주문일</th>
                                <td>{{giftOrder?.createdAt.toDate()}}</td>
                            </tr>
                            <tr>
                                <th>결제방법</th>
                                <td>{{paymentWay}}</td>
                                <th>주문상태</th>
                                <!-- <td v-if="resCode !== '3001'">{{'-'}}</td> -->
                                <td>{{giftOrder?.purchases?.paymentStatus}}</td>
                            </tr>
                            <tr>
                                <th>입금자명</th>
                                <td colspan="3">{{giftOrder?.buyer?.name}}</td>
                            </tr>
                        </table>
                    </section>

                    <section class="page-section pb-0">
                        <div class="tit-wrap mb-10px mb-md-20px">
                            <h3 class="tit tit--xs">주문하신 분</h3>
                        </div>
                        <table class="table--default">
                            <colgroup>
                                <col style="width:20%">
                                <col style="width:80%">
                            </colgroup>
                            <tr>
                                <th>주문하신분</th>
                                <td>{{giftOrder?.buyer?.name}}</td>
                            </tr>
                            <tr>
                                <th>연락처</th>
                                <td>{{giftOrder?.buyer?.phone}}</td>
                            </tr>
                            <tr>
                                <th>이메일</th>
                                <td>{{giftOrder?.buyer?.email}}</td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td v-if="giftOrder?.shippingAddress?.postcode">{{`[${giftOrder?.shippingAddress?.postcode}] ${giftOrder?.shippingAddress?.address1} ${giftOrder?.shippingAddress?.address2}`}}</td>
                            <td v-else></td>
                            </tr>
                            <tr>
                                <th>받는사람 연락처</th>
                                <td>{{giftOrder?.receiver?.phone}}</td>
                            </tr>
                        </table>
                    </section>

                    <div class="mt-20px mt-md-30px">
                        <v-row align="center" justify="center" class="row--x-small">
                            <v-col cols="auto">
                                <v-btn large outlined color="gray" to="/"><span class="grey--text text--darken-3">홈으로가기</span></v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn large color="primary" to="/mypage/shop/purchases">주문배송확인</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import { mdiReceipt, mdiBookOpenPageVariant  } from "@mdi/js";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
export default {
    components: {
        PickupItem,
    },
    data(){
        return {
            mdiReceipt,
            mdiBookOpenPageVariant,

            ready: false,
            giftOrder: null,
            purchases: null,

            resCode: this.$route.query.resCode,
            resMessage: this.$route.query.resMessage,

            purchasesHeaders: [
                { text: "이미지", value: "product", align: "center", width: "14%" },
                { text: "구매상품정보", value: "name", align: "center", width: "auto" },
                { text: "제품가격", value: "saleAmount", align: "center", width: "14%" },
                { text: "적립금", value: "earnPointAmount", align: "center", width: "14%" },
                { text: "구매수량", value: "quantity", align: "center", width: "14%" }
            ]
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            // 상품페이지 & 장바구니에서 픽업된 상품 로드
            let { giftOrder } = await api.v1.me.shop.giftOrders.get({ _id: this.$route.query._order });
            this.giftOrder = giftOrder;
            console.log(giftOrder)
            this.purchases = [giftOrder.purchase]
            this.ready = true;
        },
        open(url){
            window.open(`https://daehanbooks.co.kr/${url}`)
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },
        totalAmount(){
            return this.giftOrder?.saleAmount + this.giftOrder?.shippingAmount - this.giftOrder?.pointAmount - this.giftOrder?.cashAmount || 0
        },
        paymentWay(){
            let str = ""
            if(this.giftOrder?.cashAmount && this.giftOrder?.pointAmount && !this.giftOrder?.paymentAmount) str =  '캐시 & 포인트 결제'
            if(this.giftOrder?.cashAmount && !this.giftOrder?.pointAmount && !this.giftOrder?.paymentAmount) str =  '캐시 결제'
            if(!this.giftOrder?.cashAmount && this.giftOrder?.pointAmount && !this.giftOrder?.paymentAmount) str =  '포인트 결제'
            if(!this.giftOrder?.cashAmount && !this.giftOrder?.pointAmount && this.giftOrder?.paymentAmount) str =  '신용카드 결제'
            if(!this.giftOrder?.cashAmount && this.giftOrder?.pointAmount && this.giftOrder?.paymentAmount) str =  '신용카드 & 포인트 결제'
            if(this.giftOrder?.cashAmount && !this.giftOrder?.pointAmount && this.giftOrder?.paymentAmount) str =  '신용카드 & 캐시 결제'
            if(this.giftOrder?.cashAmount && this.giftOrder?.pointAmount && this.giftOrder?.paymentAmount) str =  '신용카드 & 캐시 & 포인트 결제'
            return str
        },
    }
}
</script>

<style scoped>
.row + .row {
    margin-top: 0px;
}
.v-input >>> .v-input__slot:before {
    bgiftOrder: 0 !important;
}
</style>